// TODO: Currency formatting is hardcoded to US locale (en-US).
// Should support international currency formatting in the future.
export function getCurrencyInLocaleFormat(number) {
  // Hardcoded to 'en-US' locale for US currency formatting ($X,XXX.XX)
  return new Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }).format(number);
}
const ROUTE={
 CUSTOMER: "/customer",
 SITES:"/sites",
  INVITE:"/invite"
}
const TEXT={
  SETME:"setme",
  KEGTRON:"Kegtron",
}
// Which pre-auth /invite flow an email belongs to. Only used to label
// error-log entries, so a failure says which button the user pressed.
const INVITE_KIND = {
  INVITATION: "invitation",
  PASSWORD_RESET: "passwordReset",
};
// localStorage key holding the path to return to after login (Pro Wi-Fi
// Provisioning: /add-device?claim=<pubkey> when the session has expired).
const ADD_DEVICE_RETURN_TO_KEY = "addDeviceReturnTo";
// localStorage key holding the path to return to after login when a
// logged-out visitor lands directly on /subscribe (e.g. a bookmarked or
// shared link, or the "Add ports" CTA after a session expired).
const SUBSCRIBE_RETURN_TO_KEY = "subscribeReturnTo";
export {
ROUTE,
TEXT,
INVITE_KIND,
ADD_DEVICE_RETURN_TO_KEY,
SUBSCRIBE_RETURN_TO_KEY
}